<template>
  <b-modal
    v-model="modal_status"
    title=""
    hide-footer
    hide-header
    ok-only
    size="xl"
    @hide="closeModal()"
    cancel-title="Close"
    ok-title="History"
  >
    <div>
      <span
        ><img
          width="16"
          class="mr-2"
          src="../../../assets/images/icons/solid/show_history.svg"
        />
        History</span
      >
      <span v-if="automation_history.data.length > 0"
        ><button class="button large-button float-right">Download</button></span
      >
      <div class="padding-12-top-bottom">
        <div class="automation-title mb-2">{{ automation.name }}</div>
        <div class="automation-description mb-2">
          <span v-html="automation.sentence">{{ automation.sentence }}</span>
        </div>
        <div class="footer-details">
          <span class="mr-3">Creator Name: {{ automation.created_by }}</span>
          <span class="mr-3">Date Created: {{ automation.created_at }}</span>
          <span>Last Change: {{ automation.updated_at }}</span>

          <span v-if="automation_history.data.length > 0">
            <b-pagination
              align="right"
              :total-rows="automation_history.meta.count"
              v-model="current_page"
              :per-page="parseInt(per_page)"
            >
            </b-pagination>
          </span>
        </div>
        <div class="mt-2">
          <table
            v-if="automation_history.data.length > 0"
            class="table table-bordered"
          >
            <thead>
              <tr>
                <th class="green-content">#</th>
                <th class="green-content">Username</th>
                <th class="green-content">Phone</th>
                <th class="green-content">Date</th>
                <th class="green-content">Time</th>
                <th class="green-content">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(history, index) in automation_history.data"
                :key="index"
              >
                <td>{{ history.provider.id }}</td>
                <td>
                  {{ history.provider.first_name }}
                  {{ history.provider.last_name }}
                </td>
                <td>{{ history.provider.phone }}</td>
                <td>{{ history.action_date }}</td>
                <td>{{ history.action_time }}</td>
                <td class="success" v-if="history.success">Success</td>
                <td class="failure" v-else>Failure</td>
              </tr>
            </tbody>

          </table>


          <div v-else class="text-center mt-2">
            <h5>
              No record found for <i>{{ automation.name }}</i>
            </h5>
          </div>
			<span v-if="automation_history.data.length > 0" class="float-right">Showing {{ from }} to {{ to }} of {{ automation_history.meta.count }}</span>

        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: {
    automation: {
      required: true,
    },
    automation_history: {
      required: true,
    },
  },
  computed: {
    upButtonEnable() {
      return;
    },
    current_page: {
      get() {
        return parseInt(this.automation_history.meta.page);
      },
      set(page) {
        this.$emit("setPageAutomationHistory", false, page);
      }
    },
	from(){
		// as long as page is 1 - show  0
		if(this.current_page == 1){
			return 0
		}
		else{
			return (this.current_page - 1) * this.per_page
		}
	},
	to(){
		if(this.automation_history.meta.count <= this.per_page && this.automation_history.meta.page == 1){
			return this.automation_history.meta.count
		}else{
			if(this.automation_history.meta.count - this.from < this.per_page){
				return this.from
			}else{
				return this.from + this.per_page
			}
		}

	}
  },
  data: function () {
    return {
      modal_status: true,
      real_length: 14,
      automation_history_page: 1,
	  per_page: 20
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeAutomationHistory");
    },
    movePage() {
      this.$emit(
        "setPageAutomationHistory",
        false,
        this.automation_history.meta.current_page
      );
    },
  },
};
</script>
<style src="../automation.css"></style>


// WEBPACK FOOTER //
// src/components/automation/automationSharedView/automationHistory.vue